
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface DeviceSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export const DeviceSearch = ({ searchQuery, onSearchChange }: DeviceSearchProps) => {
  return (
    <div className="relative flex-1">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
      <Input
        type="text"
        placeholder="Search devices..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-9 w-full rounded-full border-gray-200"
      />
      {searchQuery && (
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-2 top-1/2 -translate-y-1/2 h-6 w-6"
          onClick={() => onSearchChange("")}
          aria-label="Clear search"
        >
          <X className="h-4 w-4 text-gray-500" />
        </Button>
      )}
    </div>
  );
};
